import { handleErrorApi } from "../../helpers/randoms";
import ComprasService from "../../services/ComprasService";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

const baseUrl = process.env.REACT_APP_API_URL;

export const getDocumentacionCotizacionPorId = (idCabeceraCotizacion) => async (dispatch) => {
    try {
        const response = await ComprasService.TraerDocumentacionPorId(idCabeceraCotizacion);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.getDocumentacionXIdCabeceraCotizacion,
                payload: body
            });
        }
    } catch (error) {
        handleErrorApi(
            dispatch,
            error,
            "Error al obtener documentación",
            "Ha ocurrido un error. Intente nuevamente"
        );
    }
}

export const setDocumentacionCotizaciones = (file, idCabeceraCotizacion, idOferente, idTipoDocu) => async (dispatch) => {
    try {
        dispatch(startSpinner());
        
        const formData = new FormData();
        formData.append("file", file);
        const token =
            localStorage.getItem("token") || sessionStorage.getItem("token") || "";
        let httpHeaders;
        if (token) {
            httpHeaders = {
                Authorization: `Bearer ${token}`,
            };
        }
        const response = await fetch(
            `${baseUrl}/CotizacionesDocumentacion/${idCabeceraCotizacion}/${idOferente}/${idTipoDocu}`,
            {
                method: "POST",
                body: formData,
                headers: httpHeaders,
            }
        );
        const body = await response.json(); 
        if(response.ok){
            dispatch(getDocumentacionCotizacionPorId(idCabeceraCotizacion));
            dispatch(finishSpinner());
            dispatch(
                startAlerta(
                  "Datos Guardados Exitosamente",
                  "success",
                  "Comando Exitoso"
                )
              );
        }else{
            throw body; 
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(
          dispatch,
          error,
          "Error al guardar el documento.",
          "Ha ocurrido un error. Intente nuevamente."
        );
    }
}

export const DeleteDocumentacion = (idCotizacionDocumentacion, idCabeceraCotizacion) => async (dispatch) => {
    dispatch(startSpinner());
    try{
        const response = await ComprasService.DeleteDocumentacion(idCotizacionDocumentacion); 
        const body = await response.json();
        if(response.ok){
            dispatch(getDocumentacionCotizacionPorId(idCabeceraCotizacion));
            dispatch(finishSpinner());
            dispatch(
                startAlerta(
                    "Documento Eliminado Exitosamente",
                    "success",
                    "Comando Exitoso"
                )
            )
        }else{
            throw body;
        }
    }catch(error){
        dispatch(finishSpinner());
        handleErrorApi(
            dispatch,
            error,
            "Error al eliminar el documento.",
            "Ha ocurrido un error. Intente nuevamente."
          );
    }
};

export const fetchTipoDocumentacion = () => async (dispatch) => {
    dispatch(startSpinner());
    try{
        const response = await ComprasService.TraerTipoDocumentacion(); 
        const body = await response.json();
        if(response.ok){
            dispatch({
                type: types.getTiposDocumentacion,
                payload: body
            })
            dispatch(finishSpinner());
          
        }else{
            throw body;
        }
    }catch(error){
        dispatch(finishSpinner());
        handleErrorApi(
            dispatch,
            error,
            "Error al traer la documentacion.",
            "Ha ocurrido un error. Intente nuevamente."
          );
    }
};
